<template>
    <div>
        <cargo-seach :startDate.sync="startDate" :endDate.sync="endDate" :keyword.sync="keyword" @search="reset" :payMethod.sync="PayMethod" />
        <cargo-content v-for="(content,index) in orders" v-bind:key="index" :index="index" :contents="content" :type="type" />
        <loadmore v-if="!lastPage" @loadMore="loadMore" />
    </div>
</template>

<script>

    import CargoContent from '@/components/cargo/CargoContent'
    import CargoSeach from '@/components/cargo/CargoSeach'
    import Loadmore from '@/components/partial/Loadmore'
    import orderApi from '@/api/order'
    import moment from 'moment'

    export default {
        name:'orderTab',
        props: {
            type: {
                type: [String, Number],
                default() {
                    return 1 ; // 1 == 訂單查詢、 2 == 取消訂單
                },
            },
        },
        data() {
            return {
                format: 'yyyy-MM-dd',
                apiFormat: 'YYYY/MM/DD',
                startDate: null,
                endDate: null,
                keyword: '',
                PayMethod: '',
                orders: [],
                lastPage: false,
                currentPage: 1,
                perPage: 20,
            }
        },
        computed: {
            OrderBTime() {
                if (!this.startDate) {
                    return undefined;
                }
                return this.customDateFormatter(this.startDate)
            },
            OrderETime() {
                if (!this.endDate) {
                    return undefined;
                }
                return this.customDateFormatter(this.endDate)
            },
            queryFilter() {
                return {
                    OrderBTime: this.OrderBTime,
                    OrderETime: this.OrderETime,
                    Keyword: this.keyword,
                    PayType: this.PayMethod,
                    CurrentPage: this.currentPage,
                    PerPage: this.perPage
                };
            },
        },
        components:{
            CargoContent,
            Loadmore,
            CargoSeach,
        },
        created() {
            this.reset()
        },
        methods: {
            reset() {
                this.orders = [];
                this.lastPage = false;
                this.currentPage = 1;
                this.loadMore();
            },
            loadMore() {
                if (this.type == 1) {
                    this.getQueryOrder();
                } else if (this.type == 2) {
                    this.getQueryCancelOrder();
                }
            },
            customDateFormatter(date, format) {
                if (format) {
                    return moment(date).format(format);
                }
                return moment(date).format(this.apiFormat);
            },
            getQueryOrder() {
                orderApi.queryOrder(this.queryFilter, this.addOrders, this.noOrders);
            },
            getQueryCancelOrder() {
                orderApi.queryCancelOrder(this.queryFilter, this.addOrders, this.noOrders);
            },
            addOrders(orders) {
                orders = orders ? orders : [];

                this.orders = this.orders.concat(orders);

                if (orders.length < this.perPage) {
                    this.lastPage = true;
                }

                this.currentPage++
            },
            noOrders(error) {
                if (_.get(error, 'Message')) {
                    alert(_.get(error, 'Message'));
                }
                this.lastPage = true;
            },
        },
    }
</script>

